/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Flex, FormControl } from '@chakra-ui/react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { WhiteModal } from './styles'
import { DescricaoCargo } from '../../../../../interfaces'
import { CargoContent } from '../../../Gestao/components/CargoContent'

interface iModalProps {
  isOpen: boolean
  onClose: () => void
  cargo: DescricaoCargo
  nivel: string
}

export const ModalVisualizarCargo: React.FC<iModalProps> = ({
  isOpen,
  onClose,
  cargo,
  nivel
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content-default"
    >
      <WhiteModal style={{ width: '66rem', maxHeight: '95vh', overflowY: 'auto' }}>
        <FormControl as={Flex} flexDir="column" gap="1rem">
          <Flex justifyContent="space-between">
            <h3
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--Azul)'
              }}
            >
              {cargo.nomeCargo} - {nivel}
            </h3>
            <Flex color="var(--Red)" _hover={{ color: 'var(--Red-hover)' }}>
              <MdClose cursor="pointer" size={18} onClick={onClose} />
            </Flex>
          </Flex>

          <Flex flexDir={'column'} gap={'1rem'}>
            <CargoContent cargo={{ ...cargo, niveis: { [nivel]: cargo.niveis[nivel] } }}/>
          </Flex>
        </FormControl>
      </WhiteModal>
    </Modal>
  )
}
